<template>
    <div
        v-if="showinactive === true || link.active === true"
        class="link-item"
        :class="{
            'link-item--changed': Object.keys(link.updated_values).length > 0,
        }"
        :data-slug="link.slug"
    >
        <div class="link-item__inner">
            <div class="link-item__switch">
                <el-switch v-model="link.active" @change="changeActiveState" />
            </div>
            <div
                class="link-item__name"
                :class="{ padded: link.highlight }"
                v-html="link.short_name ? link.short_name : link.shot_name"
            ></div>
            <div class="link-item__highlight">
                <Icon v-if="link.highlight && !socialLink">
                    <IconStar />
                </Icon>
            </div>
            <div class="link-item__clicks grey">
                {{ link.clicks_count }} clicks
            </div>
            <div class="link-item__actions">
                <span
                    class="link-item__action"
                    @click="$emit('edit', link.type, false, link.slug)"
                >
                    <Button size="small">Edit</Button>
                </span>
                <Button
                    class="link-item__action"
                    @click="deleteLink"
                    size="small"
                    type="red"
                >
                    Delete
                </Button>
            </div>
        </div>
        <div class="link-item__sorthandle">
            <i class="el-icon-rank"></i>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import Icon from '@/components/Icon.vue';
import IconStar from '@/components/icons/IconStar.vue';
import Button from '@/components/Button.vue';

export default {
    components: {
        Icon,
        IconStar,
        Button,
    },
    props: {
        link: {
            type: Object,
            default: () => {},
        },
        showinactive: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        socialLink() {
            return this.link.type.includes('social-');
        },
    },
    methods: {
        deleteLink() {
            this.$confirm(
                'Are you sure you want to delete this link?',
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning',
                },
            )
                .then(() => {
                    this.sendLinkDeletion();
                })
                .catch(() => {
                    console.log('cancelled');
                });
        },
        async sendLinkDeletion() {
            try {
                await api.link.delete(this.link.slug);
                this.$store.dispatch('loadTree', {
                    slug: this.$route.params.treeslug,
                });
            } catch (error) {
                console.error(error);
            }
        },
        async changeActiveState() {
            try {
                let formData = new FormData();
                formData.append('active', this.link.active);

                var response = await api.link.update(this.link.slug, formData);
                this.$emit('updateLink', response.data.data);
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>

<style lang="scss">
.link-item {
    $block: &;
    position: relative;
    display: flex;
    align-items: center;

    @include mq(tablet-landscape) {
        width: calc(100% + 40px);
    }

    &--changed {
        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background: $almost-black;
        }
    }

    &__inner {
        position: relative;
        display: grid;
        grid-template-columns: 1fr;
        background: $barely-white;
        padding: 15px 18px;
        font-size: 14px;
        line-height: normal;
        color: $dark-grey;
        flex-shrink: 0;
        width: 100%;
        transition: 300ms $ease-out-quad;

        @include mq(tablet) {
            grid-template-columns: 1fr 3fr 1fr 2fr 4fr;
            grid-template-rows: 1fr;
            width: calc(100% - 40px);
            justify-items: center;
            align-items: center;
        }
    }

    .no-touch &:hover {
        #{$block} {
            &__inner {
                background: $light-grey;
            }
            &__sorthandle {
                opacity: 1;
            }
        }
    }

    .no-touch &:not(:hover) {
        #{$block}__action {
            filter: grayscale(1);
            opacity: 0;
        }
    }

    &:not(:last-child) {
        margin-bottom: 10px;
    }

    &__switch {
        @include mq($until: tablet) {
            position: absolute;
            top: 12px;
            right: 12px;
        }
    }

    &__name {
        padding: 0 0 10px;
        justify-self: left;

        &.padded {
            padding-left: 30px;
        }

        @include mq(tablet) {
            padding: 3px 8px !important;
        }
    }

    &__highlight {
        @include mq($until: tablet) {
            position: absolute;
            top: 12px;
            left: 12px;
        }
    }

    &__clicks {
        padding: 2px;

        @include mq(tablet) {
            text-align: right;
        }

        @include mq($until: tablet) {
            font-size: 12px;
            margin-bottom: 12px;
        }
    }

    &__actions {
        display: flex;
        margin: 0 -2px;

        @include mq(tablet) {
            justify-content: flex-end;
        }
    }

    &__action {
        margin: 0 2px;
        transition: 300ms $ease-out-quad;

        @include mq($until: tablet) {
            width: 50%;

            .button {
                width: 100%;
            }
        }
    }

    &__sorthandle {
        text-align: center;
        width: 40px;
        font-size: 20px;
        opacity: 0;
        transition: 300ms $ease-out-quad;
    }
}
</style>
